import { getApi, postApi } from '../../utils/api'

export function getPosts(data) {
  return postApi({ data, endpoint: 'idwell-api/api/v3/news/posts/filter/' })
}

export function getRequestProfileRatingFeedback(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/news/posts/request-feedback/',
    params,
  })
}

export function getPostMessageTemplates(params) {
  return getApi({
    endpoint: `/api/text-module/post-snippet/`,
    params,
  })
}
